import {AddressDataWithPostalCode, Department, Municipality, Province} from "../../types/client/clientData";
import {HttpAxiosRequest} from "../httpAxiosBase";

export const HttpClientAddressData = {
    getEndpoint: (url: string): string => `cliente/domicilio-datos${url}`,

    getAddressDataByPostalCodeAndCountry: (codCountry: number, postalCode: string): Promise<AddressDataWithPostalCode> => {
        return HttpAxiosRequest.get(
            HttpClientAddressData.getEndpoint(
                `/paises/${codCountry}/localidades/${postalCode}`
            )
        );
    },

    getProvinces: (codCountry: number): Promise<Province[]> => {
        return HttpAxiosRequest.get(
            HttpClientAddressData.getEndpoint(
                `/paises/${codCountry}/provincias`
            )
        );
    },

    getPartidos: (codCountry: number, codProvince: number): Promise<Department[]> => {
        return HttpAxiosRequest.get(
            HttpClientAddressData.getEndpoint(
                `/paises/${codCountry}/provincias/${codProvince}/partidos`
            )
        );
    },

    getLocalities: (codCountry: number, codProvince: number, codPartido:number): Promise<Municipality[]> => {
        return HttpAxiosRequest.get(
            HttpClientAddressData.getEndpoint(
                `/paises/${codCountry}/provincias/${codProvince}/partidos/${codPartido}/localidades`
            )
        );
    },

    getLocalitiesByCountryProvince: (codCountry: number, codProvince: number): Promise<Municipality[]> => {
        return HttpAxiosRequest.get(
            HttpClientAddressData.getEndpoint(
                `/paises/${codCountry}/provincias/${codProvince}/localidades`
            )
        );
    },
}